<template>
  <main-layout>
    <!-- 消費税テンプレート -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-78"></menubar>
    </div>
    <div slot="header">
      <head-title class="cancel-width">
        <label slot="title">
          <label slot="title" v-if="query.templateId == null">{{$t("label.taxTemplate.templateCreated")}}</label>
          <label slot="title" v-else>{{$t("label.taxTemplate.templateEdit")}}</label>
        </label>
        <div slot="cancel">
          <div style="display: flex;justify-content: flex-end">
            <div style="display: flex;align-items: center" v-show="this.isNotEmpty(query.templateId)">
              <lvory-but
                v-auth="{ auth: '010221' }"
                @click="templatedeletePop">
                {{ $t("button.common.data.delete") }}
              </lvory-but>
              <div class="verticalLine"></div>
            </div>
            <lvory-but
              @click="back">
              {{ $t("button.common.data.cancel") }}
            </lvory-but>
          </div>
        </div>
        <narrow-down
          v-auth="{ auth: '010221' }"
          slot="create"
          @click="templateCreateOrEdit">
          {{ $t("button.common.data.create") }}
        </narrow-down>
      </head-title>
    </div>

    <div slot="body">
      <div style="margin-bottom: 16px;">
        <el-row>
          <el-col :span="22">
            <div class="tax-template-edit">{{$t("label.taxTemplate.taxTemplate")}}</div>
          </el-col>
        </el-row>
      </div>
      <hr class="hr-style">
      <div class="required">
        <span class="red">
          *
        </span>
        {{$t("label.taxTemplate.requirTitle")}}
      </div>
      <div class="template-form-box">
        <el-form class="pointInfo" :model="query" :rules="rules" ref="ruleForm" :hide-required-asterisk="true">
          <!-- テンプレート名 -->
          <el-form-item prop="templateName" class="master-start tax-templant-title" :label="$t('label.taxTemplate.templateName')">
            <el-input type="text" class="templateNameInput" maxlength="50" show-word-limit v-model="query.templateName" :placeholder="$t('label.taxTemplate.templateName')" @input="changeContentNm">

            </el-input>
            <!-- <span
              style="
                pointer-events: none;
                position: absolute;
                font-size: 12px;
                opacity: 0.5;
                color: rgb(82, 82, 80) !important;
                left: 430px;
                top: 0px;
                height: 23px;
                width: 80px;
                display: block;
                text-align: right;
              "
            >
              {{ changeNm }}/50
            </span> -->
          </el-form-item>
          <!-- 消費税率 -->
          <el-form-item prop="taxRate" class="master-start tax-templant-title margin-24" :label="$t('label.taxTemplate.taxRate')" >
            <el-input class="taxRateInput" v-model="query.taxRate" placeholder="10"></el-input><label style="color: #525250;">%</label>
          </el-form-item>
          <!-- 端数処理方法 -->
          <el-form-item prop="decimalManageMethod" class="master-start tax-templant-title" :label="$t('label.taxTemplate.decimalManageMethod')">
            <div>
              <el-select
                type="slelct"
                v-model="query.decimalManageMethod"
                class="el-select-method"
              >
                <el-option
                  v-for="item in decimalManageMethodList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="isNotEmpty(query.templateId)">
        <div class="m-top-57">
          <el-row>
            <el-col style="margin-top: 5px;" :span="12">
              <label class="applicable-title">適用されている施設一覧</label>
            </el-col>
            <el-col :span="12">
              <div class="st-page-size">
                <label class="label lb2 lable-right-16">{{ $t("label.common.count") }}</label>
                <el-select
                  v-model="searchResult.pageSize" @change="updateSel">
                  <el-option
                    v-for="item in queryNumberList"
                    :key="item.key"
                    :label="item.code"
                    :value="item.key">
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
        </div>

        <el-table :data="searchResult.body" style="width: 100%; min-width: 1235px;"
            :default-sort="{prop: 'date', order: 'descending'}">
            <!-- ビル名 -->
            <el-table-column
              prop="buildingName"
              class-name="col-3"
            >
              <template slot="header">
                <div>
                  <span>ビル名</span>
                  <img src="@/assets/icon/bt_filter_on_off.svg" style="top: 3px; left: 4px; position: relative;" @click="sortData('buildingName')">
                </div>
              </template>
            </el-table-column>
            <!-- フロア名 -->
            <el-table-column
              prop="floorName"
              class-name="col-2"
            >
              <template slot="header">
                <div>
                  <span>フロア名</span>
                  <img src="@/assets/icon/bt_filter_on_off.svg" style="top: 3px; left: 4px; position: relative;" @click="sortData('floorName')">
                </div>
              </template>
            </el-table-column>
            <!-- 施設名 -->
            <el-table-column
              prop="roomName"
              class-name="col-13"
            >
              <template slot="header">
                <div>
                  <span>施設名</span>
                  <img src="@/assets/icon/bt_filter_on_off.svg" style="top: 3px; left: 4px; position: relative;" @click="sortData('roomName')">
                </div>
              </template>
            </el-table-column>
        </el-table>

        <!-- ページ 開始  -->
        <pagination
          class="pagination"
          v-show="pagingShow"
          :totalCount="searchResult.totalCount"
          :totalPage="searchResult.totalPage"
          :pageSize="searchResult.pageSize"
          :pageNumber="searchResult.pageNumber"
          @on-paging="handlePagingAction" />
        <!--  ページ 終了  -->
      </div>

      <el-dialog-prompt
        :clickFlag="false"
        :visible.sync="centerDialogVisibleIsShow"
        :contentMsg="msgParam"
        :titleMsg="titleParam"
        :colorFlag="true"
        @on-confirm="isPassParam">
      </el-dialog-prompt>

      <loading-dialog :dialogVisible="showLoading" />

    </div>

  </main-layout>
</template>

<script>
import Menubar from "@/components/leftmenu/DashBoard"
import MainLayout from "@/layout/NewDesignLayout"
import SystemManageApi from "@/api/SystemManageApi"
import errorCodeMsg from "@/utils/error-code-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import headTitle from "@/components/common/head/head";
import LvoryBut from "@/components/common/generalButton/LvoryBut";
import elDialogPrompt from "@/components/common/el-dialog-prompt/confirm";
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import Pagination from "@/components/common/pagination/Pagination";
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;


export default {
  name:'FaqManagement',
  components: {
    MainLayout: MainLayout,
    narrowDown: narrowDown,
    Menubar,
    headTitle,
    LvoryBut,
    elDialogPrompt,
    LoadingDialog,
    Pagination
  },
  data() {
    return {
      //タイトル表示に使用
      queryNumberList: [
        { key: 10, code: "10件" },
        { key: 20, code: "20件" },
        { key: 50, code: "50件" },
      ],
      //結果宣言に戻る
      changeNm: 0,
      searchResult: {
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
        totalPage: 0,
        totalCount: 0,
        body: [
        ],
      },
      sequence: null,
      showLoading: false,
      centerDialogVisibleIsShow: false,
      msgParam: null,
      titleParam: null,
      query: {
        ownerId: null,
        templateId: null,
        templateName: null,
        taxRate: null,
        decimalManageMethod: "01",
        ownerExId: null,
        ownerName: null,
        description: null,
        meetRoomList: null
      },
      decimalManageMethodList: [
        {value: "01", label: "切上"},
        {value: "02", label: "切捨"},
        {value: "03", label: "四捨五入"},
      ],
      rules: {
        templateName: [
          {
            required: true,
            trigger: "change",
            message: this.$t("message.common.validation.required", {
              field: this.$t("label.taxTemplate.templateName"),
            }),
          },
        ],
        taxRate: [
          {
            required: true,
            trigger: "change",
            message: this.$t("message.common.validation.required", {
              field: this.$t("label.taxTemplate.taxRate"),
            }),
          },
          {
            pattern: /^(?:[1-9]\d*|0)(?:\.\d+)?$/,
            trigger: 'change',
            message: this.$t('message.common.error.ERR_TYPE_MSG')
          },
          {
            pattern: /^(0(\.\d+)?|[1-9]?\d(\.\d+)?)$/,
            trigger: 'change',
            message: this.$t('message.common.ERR_OVER_MAX_VALUE_MSG', {
              field: this.$t("label.taxTemplate.taxRate"),
            })
          },
          {
            pattern: /^(100(\.0{1,3})?|[1-9]?\d(\.\d{1,3})?|0(\.\d{1,3})?)$/,
            trigger: 'change',
            message: this.$t('message.common.ERR_OVER_NUMBER_OF_DIGITS_MSG', {
              field1: this.$t("label.taxTemplate.taxRate"),
              field2: "5",
            })
          }
        ],
        decimalManageMethod: [
          {
            required: true,
            trigger: "change",
            message: this.$t("message.common.validation.required", {
              field: this.$t("label.taxTemplate.decimalManageMethod"),
            }),
          },
        ],
      }

    }
  },
  computed: {
    pagingShow() {
      return this.searchResult.body.length > 0;
    }
  },
  created() {
    this.$authCheck("010220");

    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/owners/search",
        title: "label.router.owner",
      },
      {
        path: "",
        title: "label.router.ownerSetting",
      },
      {
        path: "",
        title: "消費税テンプレート",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);

  },
  watch: {

  },
  mounted() {
    this.query.ownerId = this.$route.query.ownerId
    this.query.templateId = this.$route.query.templateId
      if(this.isNotEmpty(this.query.templateId)){
      this.getTemplateDetail()
    }
  },
  methods: {
    changeContentNm(val) {
      this.changeNm = this.$checkContentLength(val);
    },
    back() {
      this.$router.back()
    },
    roundToDecimal(num, decimals) {
      const factor = Math.pow(10, decimals); // 10^n
      return Math.round(num * factor) / factor;
    },
    templateCreateOrEdit(){
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.msgParam = "この内容で登録しますか？"
          this.titleParam = "登録確認"
          this.centerDialogVisibleIsShow = true
        }
      });
    },

    templatedeletePop(){
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.searchResult.body.length == 0) {
            this.msgParam = "このテンプレートを削除しますか？"
            this.titleParam = "削除確認"
            this.centerDialogVisibleIsShow = true
          }else{
            this.$messageIotError(this.$t("message.common.error.ERR_RELATION_ROOM_EXIST_DATA_MSG"))
          }

        }
      });
    },

    isPassParam() {
      if(this.titleParam == "削除確認"){
        this.deleteTemplate()
      } else if(this.query.templateId == null) {
        this.templateCreate()
      } else {
        this.templateEdit()
      }
    },
    templateCreate() {
      this.showLoading = true
      SystemManageApi.SystemTaxTemplateCreate({
        ownerId: this.query.ownerId,
        templateName: this.query.templateName,
        taxRate: this.roundToDecimal(this.query.taxRate / 100, 5),
        decimalManageMethod: this.query.decimalManageMethod,
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({data}) => {
        if(data.statusCode == "Success") {
          this.query.templateId = data.body.templateId;
          this.$router.back()
          this.$messageIotSuccess(this.$t("message.common.createSuccess", { field: 'テンプレート' }))
        } else {
          return;
        }
      }).finally(() => {
        this.showLoading = false
      })
    },

    templateEdit() {
      this.showLoading = true
      SystemManageApi.SystemTaxTemplateUpdate(this.query.templateId, {
        templateName: this.query.templateName,
        taxRate: this.roundToDecimal(this.query.taxRate / 100, 5),
        decimalManageMethod: this.query.decimalManageMethod,
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({data}) => {
        if(data.statusCode == "Success") {
          this.$router.back()
          this.$messageIotSuccess(this.$t("message.common.createSuccess", { field: 'テンプレート' }))
        }
      }).finally(() => {
        this.showLoading = false
      })
    },

    getTemplateDetail() {
      this.showLoading = true
      SystemManageApi.SystemTaxTemplateDetail(this.query.templateId)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({data}) => {
//       const data = {
//   "statusCode": "Success",
//   "message": "null message",
//   "body": {
//     "meetRoomList": [
//       {
//         "ownerId": "bd7fda33605a4b62a163b04300eb59a6",
//         "ownerExId": "0718test",
//         "ownerName": "0718test",
//         "buildingId": "a3281872c0c54edc87aeb0ad00d2e3c7",
//         "buildingExId": "BL1101T1",
//         "buildingName": "1101T1",
//         "floorId": -2,
//         "floorName": "B2",
//         "areaId": "bb3cc358fc8a4f769a94b20c00ee6115",
//         "areaName": "newhytest1",
//         "roomName": "hytest1879-含消费税"
//       }
//     ],
//     "templateName": "sy-test-消费税02",
//     "taxRate": 0.1,
//     "decimalManageMethod": "02",
//     "ownerId": "bd7fda33605a4b62a163b04300eb59a6",
//     "ownerExId": "0718test",
//     "ownerName": "0718test",
//     "description": null
//   }
// }
        if(data.statusCode == "Success") {
          this.query.templateName = data.body.templateName,
          this.changeNm = this.$checkContentLength(data.body.templateName);
          this.query.taxRate = this.roundToDecimal(data.body.taxRate * 100, 5),
          this.query.decimalManageMethod = data.body.decimalManageMethod
          this.query.ownerExId = data.body.ownerExId
          this.query.ownerName = data.body.ownerName
          this.query.description = data.body.description
          this.query.meetRoomList = data.body.meetRoomList

          this.PaginateMeetRoomList()

        }
      }).finally(() => {
        this.showLoading = false
      })
    },

    deleteTemplate() {
      this.showLoading = true
      SystemManageApi.SystemTaxTemplateDelete(this.query.templateId)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({data}) => {
        if(data.statusCode == "Success") {
          this.$router.back()
          this.$messageIotSuccess(this.$t("message.common.deleteSuccess", { field: 'テンプレート' }))
        }else if(data.statusCode == "NOT_EXIST_DATA") {
          this.$messageIotError(this.$t("message.common.error.ERR_NOT_EXIST_DATA_MSG", { field: 'テンプレート' }))
        }else if(data.statusCode == "RELATION_ROOM_EXIST_DATA") {
          this.$messageIotError(this.$t("message.common.error.ERR_RELATION_ROOM_EXIST_DATA_MSG"))
        }
      }).finally(() => {
        this.showLoading = false
      })
    },
    isNotEmpty(obj) {
      if (null != obj && "" != obj && typeof obj != "undefined") {
        return true;
      } else {
        return false;
      }
    },

    sortData(key){
      if (this.sequence === 'asc') {
          this.query.meetRoomList.sort((a, b) => {return String(a[key]).localeCompare(String(b[key]), 'ja-JP-u-ca-japanese-kf-upper')});
          // this.sequence = 'desc'
          this.sequence = ''
      } else {
          // this.query.meetRoomList.sort((a, b) => {return String(b[key]).localeCompare(String(a[key]), 'ja-JP-u-ca-japanese-kf-upper')});
          this.sequence = 'asc'
      }
      this.updateSel()

    },

    handlePagingAction(paging) {
      this.searchResult.pageSize   = paging.pageSize
      this.searchResult.pageNumber = paging.pageNumber
      this.PaginateMeetRoomList()
      this.$refs.searchResultTable.scrollIntoView()
    },

    updateSel() {
      this.searchResult.pageNumber = 1
      this.PaginateMeetRoomList();
      this.$forceUpdate();
    },

    PaginateMeetRoomList(){
      this.searchResult.totalCount = this.query.meetRoomList.length
      this.searchResult.totalPage = this.query.meetRoomList.length / this.searchResult.pageSize
      const start = (this.searchResult.pageNumber - 1) * this.searchResult.pageSize;
      const end = start + this.searchResult.pageSize;
      this.searchResult.body = this.query.meetRoomList.slice(start, end);
    }
  }
}
</script>

<style scoped lang="scss">

.cancel-width{
  ::v-deep .title label{
    width: 500px;
  }
}

.verticalLine {
  width: 1px;
  height: 25.5px;
  border: 1px solid #B8B8B3;
  margin: 21px;
}

.tax-template-edit{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 20px;
  font-weight: 300;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #525250;
}

.hr-style{
  background-color: #D1D1CD;
  height: 2px;
  margin-bottom: 16px;
}

.required{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #525250;
}

.red {
  color: #E65245;
}

.template-form-box {
  margin-top: 40px;
}

.tax-templant-title {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 16px;
  font-weight: 300;
  line-height: 27px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}

.templateNameInput {
  width: 511px;
  margin-left: 74px;
  ::v-deep.el-input__inner {
    width: 511px!important;
    height: 68px;
    padding-right: 54px;
  }
  // ::v-deep.el-input__count {
  //   background-color: transparent;
  // }
}

.taxRateInput {
  width: 82px;
  margin-left: 122px;
  margin-right: 12px;
  ::v-deep.el-input__inner {
    width: 82px!important;
    height: 44px;
  }
}

.el-select-method {
  margin-left: 90px;
  width: 140px;
}

.margin-24 {
  margin: 24px 0;
}

::v-deep .el-form-item__error{
  left: 200px;
}

.applicable-title{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 20px;
  font-weight: 300;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.m-top-57 {
  margin-top: 57px;
  margin-bottom: 24px;
}
.pagination {
  margin-top: 30px;
}
</style>
